/**
 * Removes any repeated "Bearer " prefixes and returns the raw token value.
 */
export function stripBearerToken(value: string | null | undefined): string {
  if (!value?.trim()) {
    return '';
  }

  return value.replace(/^(Bearer\s+)+/i, '').trim();
}

/**
 * Ensures the value has exactly one "Bearer " prefix.
 */
export function ensureBearerToken(value: string | null | undefined): string {
  const raw = stripBearerToken(value);
  return raw ? `Bearer ${raw}` : '';
}
